import { WidgetTheme } from '../../WidgetTheme'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetProps } from '../../widget.types'
import * as Styles from './styles'

export const Skeleton = ({ service, tipOrder }: WidgetProps) => {
  const theme = useThemeConfig({ service })

  return (
    <WidgetTheme theme={theme.loading} tipOrder={tipOrder}>
      <Styles.Container>
        <Styles.Box>
          <Styles.InfoContainer>
            <Styles.HeaderContainer>
              <Styles.Skeleton width={265} height={24} />
              <Styles.Skeleton width={165} height={24} />
            </Styles.HeaderContainer>
            <Styles.SubHeaderContainer>
              <Styles.Skeleton width={265} height={12} />
              <Styles.Skeleton width={265} height={12} />
              <Styles.Skeleton width={165} height={12} />
            </Styles.SubHeaderContainer>
            <Styles.ActionsSkeleton>
              <Styles.Skeleton width={300} height={48} />
            </Styles.ActionsSkeleton>
          </Styles.InfoContainer>
        </Styles.Box>
        <Styles.Box />
      </Styles.Container>
    </WidgetTheme>
  )
}
